import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';

// Reason + (optional) fresh TOTP code for critical operations. The backend
// verifies the code; this dialog only collects it.
export const StepUpDialog = ({ open, title, description, needTotp = true, needReason = true, onSubmit, onClose }) => {
  const [code, setCode] = useState('');
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);

  const close = () => { setCode(''); setReason(''); onClose(); };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const ok = await onSubmit({ totp_code: code.trim(), reason: reason.trim() });
      if (ok !== false) close();
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="bg-gray-950 border-gray-800 text-white" data-testid="stepup-dialog">
        <form onSubmit={submit} className="space-y-4">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription className="text-gray-400">{description}</DialogDescription>}
          </DialogHeader>
          {needReason && (
            <label className="block">
              <span className="text-gray-300 text-sm">Motivo (queda en auditoría)</span>
              <textarea required minLength={5} value={reason} onChange={(e) => setReason(e.target.value)} rows={3}
                className="mt-1 w-full bg-gray-900 border border-gray-800 rounded-lg px-3 py-2 text-white" data-testid="stepup-reason" />
            </label>
          )}
          {needTotp && (
            <label className="block">
              <span className="text-gray-300 text-sm">Código actual de tu app autenticadora</span>
              <input required inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value)}
                autoComplete="one-time-code"
                className="mt-1 w-full bg-gray-900 border border-gray-800 rounded-lg px-3 py-2 text-white font-mono tracking-widest" data-testid="stepup-totp" />
            </label>
          )}
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={close} data-testid="stepup-cancel">Cancelar</Button>
            <Button type="submit" disabled={busy} className="bg-[#FF6B35] hover:bg-[#e55a2a]" data-testid="stepup-confirm">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Confirmar'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default StepUpDialog;
